import { LoaderPage } from './ui/LoaderPage.jsx'
export default LoaderPage
